import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Link } from "@/components/common/Link";
const partners = [{
  name: "Aip Porte",
  logo: "https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/Risorsa-2-1.png?v=j6rvvamrz18",
  url: "https://aipporte.com/"
}, {
  name: "BT Group",
  logo: "https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/logo-BT_REDSQUARE.png?v=30m6us8ygcm",
  url: "https://btgroup.it/"
}, {
  name: "BT Glass",
  logo: "https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/LOGOBTGLASS_2024.png?v=3t30r0gapj2",
  url: "https://www.btglass.it/"
}, {
  name: "Elledi",
  logo: "https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/cropped-Logo-ELLEDI_payoff_color-1.webp?v=6g2dg3h245",
  url: "https://www.elledipvc.com/serramenti/"
}, {
  name: "Palagina",
  logo: "https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/logo-palagina-web.png?v=fsvz6piu6w4",
  url: "https://www.palagina.eu/"
}, {
  name: "Cappuccio",
  logo: "https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/Cappuccio_Logo.webp?v=5b6g4t9v2ot",
  url: "https://www.cappuccioserramenti.it/"
}, {
  name: "Stark Blindati",
  logo: "https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/stark.jpg?v=youwv56ahc",
  url: "https://www.starksicurezza.com/"
}];
export default function IlNostroNetwork() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="il-nostro-network" ref={ref} className="bg-background py-24 w-full">
      <div className="container mx-auto max-w-7xl px-8">
        <div className={cn("mb-16 text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h1 className="text-primary mb-4 text-4xl font-bold tracking-tight md:text-5xl">
            Partner
          </h1>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg font-light">
            Selezione dei marchi e dei collaboratori d&apos;eccellenza.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-12 md:grid-cols-4 justify-center">
          {partners.map((partner, i) => <div key={partner.name} data-index={i} className={cn("transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="group border-[#eeeeee] bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                <CardContent className="flex flex-col aspect-[3/2] items-center justify-center p-8">
                  <Link to={partner.url} newTab className="flex h-full w-full flex-col items-center justify-center">
                    <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-12 w-auto object-contain opacity-60 grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0 md:max-h-16" loading="lazy" />
                    <p className="text-[rgb(79,94,156)] mt-4 text-center text-sm font-bold">
                      {partner.name}
                    </p>
                  </Link>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}